import React from 'react';
import img from '../../../assets/logincover.svg';
import image from '../../../assets/ttecloginheader.svg';
import welimg from '../../../assets/Welcome.svg';
import Spinner from '../../shared/spinner';
import "./login.scss";

const Login = (props:any) => {
  const [showLoader, setShowLoader] = React.useState(false);
  function handleSSOLogin() {
    setShowLoader(true);
    window.location.replace(process.env.REACT_APP_BASE_URI + "login");
  } 

  const handleContactSupport = () => {
    window.location.href = "mailto:CPPO_Team@ttec.com";
  };

  return (
    <div className="login-container">
    {!showLoader && (
      <>
      <div className="left-section">
        <div className="error-status">{props.status}</div>
        <div className="project-title"><img src={image} alt="projecttitle"/></div>
        <div><img src={welimg} className="welcome-text" alt="welcometext"/></div>
        <p className="psign">Sign in with your organizational account</p>
        <button className="login-button" onClick={() => handleSSOLogin()}>Login with SSO</button>
        {/* <button className="login-button" onClick={() => handleSSOLoginTest()}>Login with SSO (Test)</button> */}
        <p className="help-text" onClick={handleContactSupport}>Having issues logging in?</p>
      </div>
      <div className="right-section">
        <div className="illustration"> 
          <img src={img} alt="Illustration" className="responsive-image" />
          </div>
        </div>
        </>
      )}
      {showLoader && (
        <>
        <div></div>
        <div className="divSpinner">
          <Spinner />
        </div>
        </>
      )}
    </div>
  );
};

export default Login;

